import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class TypeAssuranceService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/type-assurance/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/type-assurance/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/type-assurance/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/type-assurance/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/type-assurance/delete/${id}`), callback);
   

}